import $ from 'jquery';


const Donations = new (function () {
    const donations_accordion = function () {
        $("div.accordion h3").on('click', function () {
            if ($(this).hasClass('current')) {
                $(this).removeClass('current');
            } else {
                $('div.accordion h3.current').removeClass('current');
                $(this).addClass('current');
            }
        });
    };

    const donations_assist = function () {
        const submit = $('#assist_form input[type="submit"]');

        if (!submit.length) {
            return;
        }

        submit.removeAttr('disabled');

        submit.click(function() {
            $.getJSON('/assist/get_transaction_id', function(data) {
                $('#assist_form').find('input[name="OrderNumber"]').val(data.transaction_id);
                $('#assist_form').submit();
            });

            return false;
        });
    };

    const donations_assist_recurring = function () {
        function with_zero(n) {
            return n >= 10 ? n : '0' + n;
        }

        const recurring_form = $('#assist_recurring_form');

        if (!recurring_form.length) {
            return;
        }

        $('input[type="submit"]', recurring_form).removeAttr('disabled');

        const RecurringMaxDate = $('select[name="RecurringMaxDate"]', recurring_form);
        $.each([7, 13, 19, 25, 37], function (i, months) {
            var d = new Date();
            d.setMonth(d.getMonth() + months);
            d.setDate(1);

            const d_formatted = with_zero(d.getDate()) + '.' + with_zero(d.getMonth() + 1) + '.' + with_zero(d.getFullYear());

            $('<option value="' + d_formatted + '">' + d_formatted + '</option>').appendTo(RecurringMaxDate);
        });

        $('input[type="submit"]', recurring_form).click(function() {
            $.ajax({
                type: 'POST',
                url: '/assist/recurring/new',
                data: JSON.stringify ({
                    first_name:  $('input[name="Firstname"]',         recurring_form).val(),
                    last_name:   $('input[name="Lastname"]',          recurring_form).val(),
                    email:       $('input[name="Email"]',             recurring_form).val(),
                    amount:      $('input[name="OrderAmount"]',       recurring_form).val(),
                    currency:    $('select[name="OrderCurrency"]',    recurring_form).val(),
                    end_of_term: $('select[name="RecurringMaxDate"]', recurring_form).val()
                }),
                contentType: "application/json",
                dataType: 'json',
                success: function(data) {
                    if (data.status != 'ok') {
                        alert("Ошибка запроса");
                        return;
                    }

                    $('input[name="OrderNumber"]', recurring_form).val(data.transaction_id);

                    const amount = $('input[name="OrderAmount"]', recurring_form).val();
                    $('input[name="RecurringMinAmount"]', recurring_form).val(amount);
                    $('input[name="RecurringMaxAmount"]', recurring_form).val(amount);

                    recurring_form.submit();
                }
            });

            return false;
        });
    };

    this.main = function () {
        donations_accordion();
        donations_assist();
        donations_assist_recurring();
    };
})();

export default Donations;



// WEBPACK FOOTER //
// ./site/js/donations.js